<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="dataForm.username" placeholder="账号名"> </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="addOrUpdateHandle()"> 新增项目 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="项目管理">
      <div slot="extra">
        <a-button icon="redo" @click="query"> 刷新数据 </a-button>
      </div>
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
      >
        <!-- <a slot="action" slot-scope="text">action</a> -->
        <span slot="logo" slot-scope="text">
          <img @click="showImg(text)" :src="text" style="height: 40px" alt="" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              style="color: red"
              @click="projectUserSet(record.id)"
              >项目直属账号分配
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              >编辑
            </a-button>
            <a-button size="small" type="link" @click="deleteHandle(record.id)"
              >删除</a-button
            >
          </a-space>
        </span>
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
    <ProjectUserSet ref="projectUserSet"></ProjectUserSet>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/projectaddorupdate.vue";
import ProjectUserSet from "./components/projectUserSet.vue";
export default {
  mixins: [viewModule],
  components: { addOrUpdate, ProjectUserSet },
  data() {
    return {
      columns: [
        {
          title: "项目名称",
          dataIndex: "name",
          key: "name",
          align: "center",
        },
        {
          title: "项目地址",
          align: "center",
          key: "address",
          dataIndex: "address",
        },
        {
          title: "负责人",
          align: "center",
          key: "own",
          dataIndex: "own",
        },
        {
          title: "负责人联系电话",
          align: "center",
          key: "phone",
          dataIndex: "phone",
        },
        {
          title: "LOGO",
          align: "center",
          key: "logo",
          scopedSlots: { customRender: "logo" },
          dataIndex: "logo",
        },
        // {
        //   title: "项目授权功能",
        //   align: "center",
        //   scopedSlots: { customRender: "logo" },
        // },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          dataIndex: "create_time",
          filterDropdownVisible: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/project/page",
        deleteURL: "/project/delete",
      },
      dataForm: { username: "" },
    };
  },
  methods: {
    projectUserSet(id) {
      console.log(id);
      this.$refs.projectUserSet.init(id);
    },
    showImg(url) {
      this.$viewerApi({
        images: [url],
      });
    },
  },
};
</script>

<style></style>